import { ReferenceField } from 'react-admin';
import { ActivityLog, MemberNote } from '@wwf/sdk';
import { ActivityLogNote } from './ActivityLogNote';
import { MemberIcon } from '@app/member/MemberIcon';
import { MemberLightCard } from '@app/member/show/MemberLightCard';
import { ActivityLogContextValue } from './types';
import { getLinkToMember } from '@app/member/getLinkToMember';

type ActivityLogMemberNoteCreatedProps = {
    activity: ActivityLog;
    context: ActivityLogContextValue;
};

export function ActivityLogMemberNoteCreated({
    activity,
    context,
}: ActivityLogMemberNoteCreatedProps) {
    const memberNote = activity.entityData as unknown as MemberNote;

    return (
        <ActivityLogNote
            activity={activity}
            context={context}
            header={
                <>
                    <MemberIcon />
                    <ReferenceField
                        source="memberId"
                        reference="member"
                        record={memberNote}
                        link={false}
                    >
                        <MemberLightCard />
                    </ReferenceField>
                </>
            }
            text={memberNote.text ?? 'No text'}
            link={getLinkToMember(memberNote.memberId, 'show_notes')}
        />
    );
}
